module.exports = __webpack_public_path__ + "static/media/loop 03.b64ee0fe.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/video/loop 03.mp4
// module id = 579
// module chunks = 0